/**
 * Constants for MoreFeatureModal component
 */

/**
 * Dark Pool Section Constants
 * These control the dynamic height calculations for the dark pool tables
 */
export const DARK_POOL_CONSTANTS = {
  // Dark Pool Trades Table
  ROW_HEIGHT: 38.19, // Height of a single row in the dark pool trades table
  HEADER_HEIGHT: 52, // Height of the table header (includes padding)
  MAX_VISIBLE_TRADES: 10, // Maximum number of trades to display
  MIN_TABLE_HEIGHT: 150, // Minimum height for the table (in pixels)

  // Dark Pool Levels Table
  LEVELS_ROW_HEIGHT: 44, // Height of a single row in the levels table
  LEVELS_HEADER_HEIGHT: 92, // Height of the levels table header (includes title + column headers)
  MAX_VISIBLE_LEVELS: 10, // Maximum number of levels to display
  MIN_LEVELS_HEIGHT: 200, // Minimum height for the levels table (in pixels)
} as const;

/**
 * Modal Navigation Section IDs
 * These correspond to the scrollable sections within the modal
 */
export const MODAL_SECTION_IDS = {
  OPTIONS_FLOW: 'options-flow',
  OPTIONS_FLOW_TRENDS: 'options-flow-trends',
  DARK_POOL_PRINTS: 'dark-pool-prints',
  DARK_POOL_LEVELS: 'dark-pool-levels',
  PAYOFF_GRAPH: 'payoff-graph',
  PAYOFF_TABLE: 'payoff-table',
} as const;

/**
 * Navigation Items for Sidebar
 */
export const NAV_ITEMS = [
  { id: MODAL_SECTION_IDS.OPTIONS_FLOW, label: 'Options Flow' },
  { id: MODAL_SECTION_IDS.OPTIONS_FLOW_TRENDS, label: 'Options Flow Trends' },
  { id: MODAL_SECTION_IDS.DARK_POOL_PRINTS, label: 'Dark Pool Prints' },
  { id: MODAL_SECTION_IDS.DARK_POOL_LEVELS, label: 'Dark Pool Levels' },
  { id: MODAL_SECTION_IDS.PAYOFF_GRAPH, label: 'Payoff Graph' },
  { id: MODAL_SECTION_IDS.PAYOFF_TABLE, label: 'Payoff Table' },
] as const;
